export const joblist = [
  {
    title: 'Data Engineer',
    company: 'Solomon Page',
    location: 'San Francisco, CA',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/D4E0BAQErEM7GX_EUJA/company-logo_200_200/company-logo_200_200/0/1688587561903/solomon_page_group_logo?e=2147483647&v=beta&t=dZ20x9zD8UQ-FaC6rXrkB7TCUG6e44ptBkQlexpZZcw',
    work_from_home: false,
    schedule_type: 'Contract',
    h1b: false,
    exp_lvl: 'OT',
    sector: 'Retail Apparel and Fashion',
    pay_rate: null,
    salary: null,
    posted_at_str: '12 hours ago',
    apply_count_external: 33,
    rating: 6.6,
  },
  {
    title: 'Project Manager',
    company: 'Aireon LLC',
    location: 'Headquarters, KY',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/C4E0BAQF6mpfCUjy97Q/company-logo_200_200/company-logo_200_200/0/1677785247329/aireon_llc_logo?e=2147483647&v=beta&t=HsMxQa8ZJFodqiTjyC9Xf71AWxB9e6FQ-0UBQWhB4vo',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: true,
    exp_lvl: 'EN',
    sector: 'Aviation and Aerospace Component Manufacturing',
    pay_rate: null,
    salary: null,
    posted_at_str: '13 hours ago',
    apply_count_external: 25,
    rating: 6.9,
  },
  {
    title: 'Financial Analyst',
    company: 'The Fountain Group',
    location: 'New Brunswick, NJ',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/D4E0BAQHq1m8ZrsbL-A/company-logo_200_200/company-logo_200_200/0/1721830038785/the_fountain_group_logo?e=2147483647&v=beta&t=MokgCR4bSXkW0L1AMYuyTESf9Xuw6J0gq5mhpB-Pnn4',
    work_from_home: true,
    schedule_type: 'Contract',
    h1b: true,
    exp_lvl: 'SE',
    sector: 'IT Services and IT Consulting',
    pay_rate: 'hour',
    salary: '$65.00/hr - $70.00/hr',
    posted_at_str: '19 hours ago',
    apply_count_external: 200,
    rating: 7.5,
  },
  {
    title: ' Senior Product Manager',
    company: 'Zoom',
    location: 'San Jose, CA',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/D560BAQHdFe3fnAvRmg/company-logo_200_200/company-logo_200_200/0/1711361750580/zoom_video_communications_logo?e=2147483647&v=beta&t=wssg0q9oOBRuuO3kWJQl1RY0c4kNP76u_RELqER9jK8',
    work_from_home: true,
    schedule_type: 'Full-time',
    h1b: true,
    exp_lvl: 'OT',
    sector: 'IT Services and IT Consulting',
    pay_rate: null,
    salary: null,
    posted_at_str: '18 hours ago',
    apply_count_external: 200,
    rating: 8.1,
  },
  {
    title: 'AI/ML Engineer',
    company: 'Meta',
    location: 'San Francisco, CA',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/C4E0BAQFdNatYGiBelg/company-logo_200_200/company-logo_200_200/0/1636138754252/facebook_logo?e=2147483647&v=beta&t=AvNtuf0xdJHNOmiW3VQbuCSF_caX_S2PBz8PrmuVzIE',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: true,
    exp_lvl: 'OT',
    sector: 'Technology, Information and Internet',
    pay_rate: 'year',
    salary: '$249,000.00/yr - $323,000.00/yr',
    posted_at_str: '2 hours ago',
    apply_count_external: 74,
    rating: 8.6,
  },
  {
    title: 'Supply Chain Manager',
    company: 'AssetMark',
    location: 'Charlotte, NC',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/D560BAQG4iWrI8TuhBQ/company-logo_200_200/B56ZX9en1qHEAI-/0/1743714418272/assetmark_logo?e=2147483647&v=beta&t=Td1r3-rQIYd47-nnqekD2ZgCM3yTqo7PJD3iZmG5gxM',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: true,
    exp_lvl: 'EN',
    sector: 'Financial Services',
    pay_rate: 'year',
    salary: '$85,000.00/yr - $95,000.00/yr',
    posted_at_str: '3 hours ago',
    apply_count_external: 200,
    rating: 9.5,
  },
  {
    title: 'Business Dev Intern',
    company: 'Dôen',
    location: 'Los Angeles, CA',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/C4D0BAQFDKlexXhZrag/company-logo_200_200/company-logo_200_200/0/1631342878931?e=2147483647&v=beta&t=7h4M9XC3l4ctlDmjCqkMAiounnIuHb0pQPZN04Vg31I',
    work_from_home: false,
    schedule_type: 'Part-time',
    h1b: false,
    exp_lvl: 'IN',
    sector: 'Retail Apparel and Fashion',
    pay_rate: null,
    salary: null,
    posted_at_str: '14 hours ago',
    apply_count_external: 200,
    rating: 7.4,
  },
  {
    title: 'Business Analyst',
    company: 'BCforward',
    location: 'Redmond, WA',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/D560BAQF-58cvJAABug/company-logo_200_200/company-logo_200_200/0/1708016840492/bcforward_logo?e=2147483647&v=beta&t=Di_Hu0b-Rfib-8__WWdJ12giBxjoMxZA5MRql7R-b88',
    work_from_home: false,
    schedule_type: 'Contract',
    h1b: true,
    exp_lvl: 'SE',
    sector: 'Construction and Business Consulting and Services',
    pay_rate: 'hour',
    salary: '$70.00/hr - $75.00/hr',
    posted_at_str: '13 hours ago',
    apply_count_external: 114,
    rating: 9.5,
  },
  {
    title: 'Backend Developer',
    company: 'Tinder',
    location: 'Los Angeles, CA',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/C560BAQGXi3o84QXQnw/company-logo_200_200/company-logo_200_200/0/1652919833346/tinder_incorporated_logo?e=2147483647&v=beta&t=qMEPTS9fNLYYkJ-0tOTM8_DXk203CLKgpMnOnfsp8Hc',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: false,
    exp_lvl: 'OT',
    sector: 'Software Development',
    pay_rate: 'year',
    salary: '$220,000.00/yr - $230,000.00/yr',
    posted_at_str: '10 hours ago',
    apply_count_external: 41,
    rating: 8.7,
  },
  {
    title: 'Quality Assuarance Associate',
    company: 'Nira Energy',
    location: 'United States',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/C560BAQFPO1pEBTvSPw/company-logo_200_200/company-logo_200_200/0/1630672290315/nira_energy_logo?e=2147483647&v=beta&t=ox13gOvonb4DXIY6uFd7puZTKNustS341_7mdtnGIuU',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: true,
    exp_lvl: 'SE',
    sector: 'Utilities and Services for Renewable Energy',
    pay_rate: 'year',
    salary: '$160,000.00/yr - $200,000.00/yr',
    posted_at_str: '16 hours ago',
    apply_count_external: 200,
    rating: 9.4,
  },
  {
    title: 'Paralegal',
    company: 'Tarte Cosmetics',
    location: 'New York, NY',
    thumbnail: 'https://icon-library.com/images/jobs-icon-png/jobs-icon-png-20.jpg',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: true,
    exp_lvl: 'MI',
    sector: 'Personal Care Product Manufacturing',
    pay_rate: 'year',
    salary: '$70,000.00/yr - $85,000.00/yr',
    posted_at_str: '16 hours ago',
    apply_count_external: 80,
    rating: 9.0,
  },
  {
    title: 'Cloud Architect',
    company: 'Unity',
    location: 'United States',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/D4D0BAQFoRUR2DxPJiw/company-logo_200_200/company-logo_200_200/0/1682010178745/unity_logo?e=2147483647&v=beta&t=WJ9pe5OHIoDehtJSlcimxxKEfuYzN2OWnMDfUxsxctA',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: true,
    exp_lvl: 'SE',
    sector: 'Software Development',
    pay_rate: 'year',
    salary: '$161,200.00/yr - $218,100.00/yr',
    posted_at_str: '13 hours ago',
    apply_count_external: 111,
    rating: 7.8,
  },
  {
    title: 'Technical Program Manager',
    company: 'Nordstrom',
    location: 'Seattle, WA',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/D560BAQGFmI0mWPUJdw/company-logo_200_200/company-logo_200_200/0/1666026884352/nordstrom_logo?e=2147483647&v=beta&t=qunqF-rqvoaT-ZXFfMU7zN4CfnEkxaD2DZshXd9iC_U',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: true,
    exp_lvl: 'EN',
    sector: 'Retail',
    pay_rate: null,
    salary: null,
    posted_at_str: '18 hours ago',
    apply_count_external: 146,
    rating: 7.6,
  },
  {
    title: 'Operations Intern',
    company: 'Insight Global',
    location: 'United States',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/C560BAQGUNIyRZFaj0g/company-logo_200_200/company-logo_200_200/0/1657049194702/insight_global_logo?e=2147483647&v=beta&t=qgSY6S4vpAzMXSPhYkkhODSkHvK35KUnT1qfp9mqNA4',
    work_from_home: true,
    schedule_type: 'Full-time',
    h1b: true,
    exp_lvl: 'SE',
    sector: 'Insurance',
    pay_rate: 'hour',
    salary: '$60.00/hr - $75.00/hr',
    posted_at_str: '17 hours ago',
    apply_count_external: 200,
    rating: 7.1,
  },
  {
    title: 'Sales & Marketing Analyst',
    company: 'GlobalPoint Inc',
    location: 'Richmond, VA',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/D4E0BAQEE3aYURLlBTw/company-logo_200_200/company-logo_200_200/0/1728586012897/globalpointinc_logo?e=2147483647&v=beta&t=lMP5jug3a9tgy6wbcRkiJHDRnWJrtT-Su0AG5sIcW3A',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: true,
    exp_lvl: 'MI',
    sector: 'IT Services and IT Consulting',
    pay_rate: null,
    salary: null,
    posted_at_str: '23 hours ago',
    apply_count_external: 90,
    rating: 8.5,
  },
  {
    title: 'Digital Marketing Intern',
    company: 'Edit Media Group',
    location: 'New York, NY',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/C560BAQEv-395a07jRA/company-logo_200_200/company-logo_200_200/0/1631426932200/editmediagroup_logo?e=2147483647&v=beta&t=75vl2O9botxTpQmK3LMkvoQFGrDm-dAGGDTVBmEpSKw',
    work_from_home: false,
    schedule_type: 'Internship',
    h1b: true,
    exp_lvl: 'IN',
    sector: 'Social Networking Platforms',
    pay_rate: null,
    salary: null,
    posted_at_str: '18 hours ago',
    apply_count_external: 159,
    rating: 6.6,
  },
  {
    title: 'Senior Mechanical Engineer',
    company: 'Harvard University',
    location: 'Cambridge, MA',
    thumbnail: 'https://icon-library.com/images/jobs-icon-png/jobs-icon-png-20.jpg',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: true,
    exp_lvl: 'OT',
    sector: 'Higher Education',
    pay_rate: null,
    salary: null,
    posted_at_str: '23 hours ago',
    apply_count_external: 25,
    rating: 8.6,
  },
  {
    title: 'Instrumentation Engineer',
    company: 'Remi',
    location: 'Lehi, UT',
    thumbnail: 'https://icon-library.com/images/jobs-icon-png/jobs-icon-png-20.jpg',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: true,
    exp_lvl: 'SE',
    sector: 'Software Development',
    pay_rate: null,
    salary: null,
    posted_at_str: '17 hours ago',
    apply_count_external: 200,
    rating: 7.6,
  },
  {
    title: 'Healthcare Clinical Scientist',
    company: 'ATC',
    location: 'New York, United States',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/C4E0BAQHR71hWsUHv0g/company-logo_200_200/company-logo_200_200/0/1630586230009/american_technology_consulting_logo?e=2147483647&v=beta&t=T1BUSUeMIBvxdBlvdPXA5obGY7MdRsKTZzAs8VvFRvg',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: true,
    exp_lvl: 'EN',
    sector: 'IT Services and IT Consulting',
    pay_rate: null,
    salary: null,
    posted_at_str: '2 hours ago',
    apply_count_external: 44,
    rating: 8.7,
  },
  {
    title: 'Data Analyst II',
    company: 'Relativity Space',
    location: 'Long Beach, CA',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/C560BAQFKeRPssztcCQ/company-logo_200_200/company-logo_200_200/0/1630648864936/relativity_logo?e=2147483647&v=beta&t=ckISiy72_nQN0rzGoRkaVxRE9j9KuFb2iHK8sboc8cU',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: false,
    exp_lvl: 'EN',
    sector: 'Aviation and Aerospace Component Manufacturing',
    pay_rate: 'year',
    salary: '$87,000.00/yr - $111,000.00/yr',
    posted_at_str: '13 hours ago',
    apply_count_external: 200,
    rating: 7.5,
  },
  {
    title: 'E-commerce Product Manager',
    company: 'Circle K',
    location: 'Tempe, AZ',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/C4E0BAQHeweKm_DEYgw/company-logo_200_200/company-logo_200_200/0/1630619953990/circle_k_logo?e=2147483647&v=beta&t=c74rKWaLFkI-M8oslHPc_cyHZwniCWnqCnX1e8OtLOY',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: true,
    exp_lvl: 'EN',
    sector: 'Retail',
    pay_rate: null,
    salary: null,
    posted_at_str: '52 minutes ago',
    apply_count_external: 200,
    rating: 8.6,
  },
  {
    title: 'Technical Recruiter',
    company: 'XR Extreme Reach',
    location: 'United States',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/D560BAQEuhGbtxX2FFg/company-logo_200_200/company-logo_200_200/0/1720615865694/xr_extreme_reach_logo?e=2147483647&v=beta&t=FbN_xodG8wqtK6uTvzImlS0vSqAFY_d37cMszjXP-eQ',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: false,
    exp_lvl: 'EN',
    sector: 'IT Services and IT Consulting',
    pay_rate: 'year',
    salary: '$100,000.00/yr - $100,000.00/yr',
    posted_at_str: '20 hours ago',
    apply_count_external: 144,
    rating: 8.7,
  },
  {
    title: 'SDE 2',
    company: 'Netflix',
    location: 'New York, United States',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/D4E0BAQGMva5_E8pUjw/company-logo_200_200/company-logo_200_200/0/1736276678240/netflix_logo?e=2147483647&v=beta&t=-84GbYZIgL-lNtKMkXAk-OE1L6VJVMfBSLJRG8FLkVY',
    work_from_home: false,
    schedule_type: 'Contract',
    h1b: true,
    exp_lvl: 'OT',
    sector: 'Entertainment Providers',
    pay_rate: 'year',
    salary: '$240,000.00/yr - $725,000.00/yr',
    posted_at_str: '3 hours ago',
    apply_count_external: 115,
    rating: 7.7,
  },
  {
    title: 'Vice President - Growth & Strategy',
    company: 'Golden Technology',
    location: 'Durham, NC',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/C4D0BAQFfj3OvfNdbew/company-logo_200_200/company-logo_200_200/0/1631313869565?e=2147483647&v=beta&t=7QFfWXe-Y9vA87GFMK0FVFbGxtuPoie5oK1AWUQwTRc',
    work_from_home: false,
    schedule_type: 'Contract',
    h1b: true,
    exp_lvl: 'SE',
    sector: 'Pharmaceutical Manufacturing',
    pay_rate: null,
    salary: null,
    posted_at_str: '22 hours ago',
    apply_count_external: 49,
    rating: 7.1,
  },
  {
    title: 'Principal Product Manager, Growth',
    company: 'Vimeo',
    location: 'New York, NY',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/D560BAQHVXOaL_HTxHw/company-logo_200_200/company-logo_200_200/0/1716244115689/vimeo_logo?e=2147483647&v=beta&t=bqTRmw4P4bS-E_1m9UwvsW3c7xbiQfQPdKSwMGy-LPE',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: true,
    exp_lvl: 'SE',
    sector: 'Software Development',
    pay_rate: null,
    salary: null,
    posted_at_str: '1 hour ago',
    apply_count_external: 25,
    rating: 6.8,
  },
  {
    title: 'Accounting Specialist',
    company: 'Canary Technologies',
    location: 'New York, NY',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/D4E0BAQH-CxoiDymXYA/company-logo_200_200/company-logo_200_200/0/1719899740839/canarytech_logo?e=2147483647&v=beta&t=NHjrnsWCM3soSfIAp4HCbc4H-tIVx3MRRoDrMlYjvZQ',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: true,
    exp_lvl: 'EN',
    sector: 'Hospitality',
    pay_rate: 'year',
    salary: '$120,000.00/yr - $160,000.00/yr',
    posted_at_str: '19 hours ago',
    apply_count_external: 179,
    rating: 7.2,
  },
  {
    title: 'Technical Help Desk',
    company: 'Bellota Labs',
    location: 'Redwood City, CA',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/D4E0BAQHlmQ-FznGhuw/company-logo_200_200/company-logo_200_200/0/1723649548653/bellota_labs_logo?e=2147483647&v=beta&t=e1zx8EShp_S2hvoPFSMGU6hbi8AEj6aMdcIJE9OiLSA',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: false,
    exp_lvl: 'OT',
    sector: 'Computer Games',
    pay_rate: 'year',
    salary: '$175,000.00/yr - $250,000.00/yr',
    posted_at_str: '9 hours ago',
    apply_count_external: 27,
    rating: 8.5,
  },
  {
    title: 'Analyst',
    company: 'MeaningSphere',
    location: 'United States',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/D560BAQHlNoFBFyqHVQ/company-logo_200_200/company-logo_200_200/0/1727282942909/meaningsphere_logo?e=2147483647&v=beta&t=-dXxqJFxkEO8skf8frRyd34K6HoUbkDyJLwO11Hg65g',
    work_from_home: false,
    schedule_type: 'Contract',
    h1b: false,
    exp_lvl: 'EN',
    sector: 'Education',
    pay_rate: null,
    salary: null,
    posted_at_str: '14 hours ago',
    apply_count_external: 159,
    rating: 8.0,
  },
  {
    title: 'Senior Warehouse Manager',
    company: 'Ascendion',
    location: 'United States',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/C4D0BAQGHeQsU54NLQA/company-logo_200_200/company-logo_200_200/0/1663258479025/ascendion_logo?e=2147483647&v=beta&t=MrYX_zqQSn2c6FS-6yAw1Tly6aWjkyUwhVJ6pkoFWVQ',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: true,
    exp_lvl: 'SE',
    sector: 'Retail',
    pay_rate: 'year',
    salary: '$160,000.00/yr - $170,000.00/yr',
    posted_at_str: '23 hours ago',
    apply_count_external: 200,
    rating: 7.9,
  },
  {
    title: 'Project Manager',
    company: 'Signature Aviation',
    location: 'Orlando, FL',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/D560BAQHTTwNbpg_uDw/company-logo_200_200/company-logo_200_200/0/1709564763666?e=2147483647&v=beta&t=SX_hQZSZfKmSb5rWjPbAnIKT3KCIhtk84lp3NyRZahI',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: false,
    exp_lvl: 'SE',
    sector: 'Airlines and Aviation',
    pay_rate: null,
    salary: null,
    posted_at_str: '22 hours ago',
    apply_count_external: 48,
    rating: 6.9,
  },
  {
    title: 'Business Analyst',
    company: 'CGS Federal (Contact Government Services)',
    location: 'United States',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/C560BAQFtAeV4P_tW_w/company-logo_200_200/company-logo_200_200/0/1631360334310?e=2147483647&v=beta&t=5u8CW3jva9a4tdCaHlWxqtFgaga2DW-sDEYW7ko-7so',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: false,
    exp_lvl: 'MI',
    sector: 'Hospitality, Food and Beverage Services, and Retail',
    pay_rate: 'year',
    salary: '$60,000.00/yr - $110,000.00/yr',
    posted_at_str: '16 hours ago',
    apply_count_external: 25,
    rating: 8.4,
  },
  {
    title: 'Risk Analyst',
    company: 'CGS Federal (Contact Government Services)',
    location: 'United States',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/C560BAQFtAeV4P_tW_w/company-logo_200_200/company-logo_200_200/0/1631360334310?e=2147483647&v=beta&t=5u8CW3jva9a4tdCaHlWxqtFgaga2DW-sDEYW7ko-7so',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: false,
    exp_lvl: 'MI',
    sector: 'Hospitality, Food and Beverage Services, and Retail',
    pay_rate: 'year',
    salary: '$60,000.00/yr - $110,000.00/yr',
    posted_at_str: '16 hours ago',
    apply_count_external: 33,
    rating: 7.3,
  },
  {
    title: 'Business Analyst',
    company: 'CGS Federal (Contact Government Services)',
    location: 'Austin, TX',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/C560BAQFtAeV4P_tW_w/company-logo_200_200/company-logo_200_200/0/1631360334310?e=2147483647&v=beta&t=5u8CW3jva9a4tdCaHlWxqtFgaga2DW-sDEYW7ko-7so',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: false,
    exp_lvl: 'MI',
    sector: 'Hospitality, Food and Beverage Services, and Retail',
    pay_rate: 'year',
    salary: '$60,000.00/yr - $110,000.00/yr',
    posted_at_str: '16 hours ago',
    apply_count_external: 25,
    rating: 9.3,
  },
  {
    title: 'Business Analyst',
    company: 'CGS Federal (Contact Government Services)',
    location: 'Arlington, VA',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/C560BAQFtAeV4P_tW_w/company-logo_200_200/company-logo_200_200/0/1631360334310?e=2147483647&v=beta&t=5u8CW3jva9a4tdCaHlWxqtFgaga2DW-sDEYW7ko-7so',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: false,
    exp_lvl: 'MI',
    sector: 'Hospitality, Food and Beverage Services, and Retail',
    pay_rate: 'year',
    salary: '$60,000.00/yr - $110,000.00/yr',
    posted_at_str: '16 hours ago',
    apply_count_external: 25,
    rating: 8.4,
  },
  {
    title: 'Director of Supply Chain Operations',
    company: 'iRiS Recruiting Solutions',
    location: 'Bentonville, AR',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/D560BAQH82qdpy6RZDQ/company-logo_200_200/B56ZUbJ3MVHEAI-/0/1739917325487/management_recruiters_indianapolis_north_logo?e=2147483647&v=beta&t=uRXKGP6fmeccZSxJN2htnSdWHf7DMbpJUvxfQvzIS0g',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: false,
    exp_lvl: 'OT',
    sector: 'Wholesale Import and Export and Retail',
    pay_rate: 'year',
    salary: '$135,000.00/yr - $180,000.00/yr',
    posted_at_str: '16 hours ago',
    apply_count_external: 65,
    rating: 8.9,
  },
  {
    title: 'IT Support Desk Tier 1',
    company: 'Dental Care Alliance',
    location: 'Sarasota, FL',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/D4E0BAQEz-nc6Pu73BA/company-logo_200_200/B4EZZu6lx2H0AM-/0/1745617575323/dental_care_alliance_logo?e=2147483647&v=beta&t=ONN9iByAXJ7smTxbhx9HW0TkknBcWrVcziTrjkfjNRU',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: true,
    exp_lvl: 'EN',
    sector: 'Hospitals and Health Care',
    pay_rate: null,
    salary: null,
    posted_at_str: '13 hours ago',
    apply_count_external: 25,
    rating: 6.9,
  },
  {
    title: 'React Software Engineer',
    company: 'Auriga Corporation',
    location: 'Los Angeles, CA',
    thumbnail: 'https://icon-library.com/images/jobs-icon-png/jobs-icon-png-20.jpg',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: true,
    exp_lvl: 'SE',
    sector: 'Engineering Services',
    pay_rate: null,
    salary: null,
    posted_at_str: '1 day ago',
    apply_count_external: 80,
    rating: 9.4,
  },
  {
    title: 'Online Sales (New Home Specialist)',
    company: 'Tri Pointe Homes',
    location: 'Houston, TX',
    thumbnail: 'https://icon-library.com/images/jobs-icon-png/jobs-icon-png-20.jpg',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: true,
    exp_lvl: 'EN',
    sector: 'Real Estate',
    pay_rate: null,
    salary: null,
    posted_at_str: '2 hours ago',
    apply_count_external: 73,
    rating: 8.5,
  },
  {
    title: 'Data Analyst',
    company: 'Westinghouse Electric Company',
    location: 'Middlesex County, MA',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/C560BAQFWaS02vzdXNg/company-logo_200_200/company-logo_200_200/0/1649970263603/westinghouse_electric_company_logo?e=2147483647&v=beta&t=vuguAKU6VXPeKJQ8mfDUx5t_VDbYKESGMZZhHz2kkno',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: true,
    exp_lvl: 'EN',
    sector: 'Utilities',
    pay_rate: null,
    salary: null,
    posted_at_str: '7 hours ago',
    apply_count_external: 121,
    rating: 8.1,
  },
  {
    title: 'Data Analyst',
    company: 'Peregrine Search Solutions',
    location: 'United States',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/D560BAQEiWjPKMxzzig/company-logo_200_200/company-logo_200_200/0/1692044871111/peregrine_staffing_solutions_logo?e=2147483647&v=beta&t=z6syOz7_ctNVvAlOzJYPtJ3p-T7h6gcrygvSvo-9dWs',
    work_from_home: true,
    schedule_type: 'Full-time',
    h1b: false,
    exp_lvl: 'MI',
    sector: 'Beverage Manufacturing, Food and Beverage Manufacturing, and Wholesale Food and Beverage',
    pay_rate: 'year',
    salary: '$70,000.00/yr - $90,000.00/yr',
    posted_at_str: '23 hours ago',
    apply_count_external: 200,
    rating: 8.9,
  },
  {
    title: 'Data Analyst (New Grad)',
    company: 'Jobright.ai',
    location: 'Colorado, United States',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/D560BAQENJWU02sl4ZA/company-logo_200_200/company-logo_200_200/0/1701315479200/jobright_ai_logo?e=2147483647&v=beta&t=cDt-o-0-sYO_OUsvUeQMrlHGJzIfqlSelOExKlK1FTA',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: false,
    exp_lvl: 'EN',
    sector: 'Software Development',
    pay_rate: null,
    salary: null,
    posted_at_str: '18 hours ago',
    apply_count_external: 60,
    rating: 9.3,
  },
  {
    title: 'Investment Data Analyst | $60+ B Quantitative Hedge Fund | Boston (hybrid)',
    company: 'Delmar Nord',
    location: 'Greater Boston',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/D4E0BAQGQyvOZ_cJjKg/company-logo_200_200/company-logo_200_200/0/1698142128544?e=2147483647&v=beta&t=ipxugYOto2G69o59pVz1X7NO97LPKwxdseAKFUJljmI',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: false,
    exp_lvl: 'SE',
    sector: 'Investment Management',
    pay_rate: 'year',
    salary: '$100,000.00/yr - $150,000.00/yr',
    posted_at_str: '23 hours ago',
    apply_count_external: 200,
    rating: 9.2,
  },
  {
    title: 'Product Manager',
    company: 'OptionMetrics',
    location: 'New York, NY',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/C560BAQHSqwXIOk-yHg/company-logo_200_200/company-logo_200_200/0/1630581725218/optionmetrics_logo?e=2147483647&v=beta&t=jxrjKV5rhOlljbdsht5bhp5mS5-8adw5tnAxeTCAKzo',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: false,
    exp_lvl: 'SE',
    sector: 'Hospitality, Food and Beverage Services, and Retail',
    pay_rate: 'year',
    salary: '$100,000.00/yr - $150,000.00/yr',
    posted_at_str: '16 hours ago',
    apply_count_external: 105,
    rating: 8.5,
  },
  {
    title: 'Associate Product Manager',
    company: 'ScribeUp',
    location: 'New York City Metropolitan Area',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/D4E0BAQGqlj7A3-slmQ/company-logo_200_200/company-logo_200_200/0/1728584035713/scribeup_logo?e=2147483647&v=beta&t=nO9pzgbkvFOuKs0b6cRSENeoxpQWOpZdMXTGFJodp8Y',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: false,
    exp_lvl: 'EN',
    sector: 'Financial Services',
    pay_rate: 'year',
    salary: '$70,000.00/yr - $110,000.00/yr',
    posted_at_str: '16 hours ago',
    apply_count_external: 200,
    rating: 7.8,
  },
  {
    title: 'Product Manager, Digital (Distribution)',
    company: 'XR Extreme Reach',
    location: 'New York, NY',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/D560BAQEuhGbtxX2FFg/company-logo_200_200/company-logo_200_200/0/1720615865694/xr_extreme_reach_logo?e=2147483647&v=beta&t=FbN_xodG8wqtK6uTvzImlS0vSqAFY_d37cMszjXP-eQ',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: false,
    exp_lvl: 'EN',
    sector: 'IT Services and IT Consulting',
    pay_rate: 'year',
    salary: '$100,000.00/yr - $100,000.00/yr',
    posted_at_str: '20 hours ago',
    apply_count_external: 70,
    rating: 7.7,
  },
  {
    title: 'UX Designer',
    company: 'Solomon Page',
    location: 'United States',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/D4E0BAQErEM7GX_EUJA/company-logo_200_200/company-logo_200_200/0/1688587561903/solomon_page_group_logo?e=2147483647&v=beta&t=dZ20x9zD8UQ-FaC6rXrkB7TCUG6e44ptBkQlexpZZcw',
    work_from_home: true,
    schedule_type: 'Contract',
    h1b: false,
    exp_lvl: 'OT',
    sector: 'Entertainment Providers',
    pay_rate: null,
    salary: null,
    posted_at_str: '18 hours ago',
    apply_count_external: 110,
    rating: 9.2,
  },
  {
    title: 'Business Dev Intern',
    company: 'HeyGen',
    location: 'Los Angeles, CA',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/D560BAQGQeIpkHnW2dw/company-logo_200_200/B56ZZGRqrnHoAI-/0/1744935759416/heygen_logo?e=2147483647&v=beta&t=5G3Xic5h1eUQqZmSZ2QJWK-bfy8JrMYmF5NWuYKydyg',
    work_from_home: false,
    schedule_type: 'Internship',
    h1b: true,
    exp_lvl: 'SE',
    sector: 'Online Audio and Video Media',
    pay_rate: null,
    salary: null,
    posted_at_str: '6 hours ago',
    apply_count_external: 25,
    rating: 7.0,
  },
  {
    title: 'Supply Chain Analyst',
    company: 'Nike',
    location: 'Beaverton, OR',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/D560BAQHJk7IdfuV1Dw/company-logo_200_200/company-logo_200_200/0/1732131503851/nike_logo?e=2147483647&v=beta&t=a7JHcS6ZUIfLm5CCmi6VYkiJJVU23rF7ep2bCNVLprk',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: true,
    exp_lvl: 'SE',
    sector: 'Retail',
    pay_rate: null,
    salary: null,
    posted_at_str: '19 hours ago',
    apply_count_external: 62,
    rating: 8.5,
  },
  {
    title: 'GTM Manager',
    company: 'Roku',
    location: 'New York, NY',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/D4E0BAQFp3TkiD7zF3A/company-logo_200_200/B4EZU5bbIUG0AI-/0/1740425245858/roku_logo?e=2147483647&v=beta&t=Ah6K8hlkrG2m-pFjvtL7XT81wJNvBMq-Cf7Hph9XBL4',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: true,
    exp_lvl: 'SE',
    sector: 'Software Development',
    pay_rate: 'year',
    salary: '$129,000.00/yr - $374,000.00/yr',
    posted_at_str: '4 hours ago',
    apply_count_external: 200,
    rating: 6.7,
  },
  {
    title: 'Electronics Engineer',
    company: 'Larson Manufacturing',
    location: 'Greater Chicago Area',
    thumbnail:
      'https://media.licdn.com/dms/image/v2/D560BAQF4XmG7jqdENw/company-logo_200_200/company-logo_200_200/0/1706558698450/larson_manufacturing_logo?e=2147483647&v=beta&t=PfHNvN7lBAIxi1CoULc1BZa_i6JpZO9iJP7jH5f6BOM',
    work_from_home: false,
    schedule_type: 'Full-time',
    h1b: false,
    exp_lvl: 'SE',
    sector: 'Consumer Goods',
    pay_rate: 'year',
    salary: '$100,000.00/yr - $130,000.00/yr',
    posted_at_str: '4 hours ago',
    apply_count_external: 99,
    rating: 9.5,
  },
];